var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7309 15.8333C11.7309 17.2141 10.6805 18.3333 9.38485 18.3333C8.08917 18.3333 7.03881 17.2141 7.03881 15.8333M10.7897 5.1988C11.1303 4.82387 11.3399 4.31302 11.3399 3.75001C11.3399 2.59941 10.4646 1.66667 9.38485 1.66667C8.30512 1.66667 7.42982 2.59941 7.42982 3.75001C7.42982 4.31302 7.6394 4.82387 7.97996 5.1988M1.99234 6.9358C1.98112 5.72635 2.59303 4.59693 3.58156 4.00256M16.7774 6.9358C16.7886 5.72635 16.1767 4.59693 15.1882 4.00256M14.0769 9.33334C14.0769 8.18407 13.5826 7.08187 12.7027 6.26921C11.8227 5.45655 10.6293 5.00001 9.38485 5.00001C8.14044 5.00001 6.94699 5.45655 6.06705 6.26921C5.18712 7.08187 4.69277 8.18407 4.69277 9.33334C4.69277 11.2348 4.25026 12.6255 3.6981 13.6206C3.0688 14.7547 2.75414 15.3218 2.76657 15.4572C2.78078 15.6122 2.80696 15.6611 2.92491 15.753C3.028 15.8333 3.54596 15.8333 4.58187 15.8333H14.1878C15.2238 15.8333 15.7417 15.8333 15.8448 15.753C15.9628 15.6611 15.9889 15.6122 16.0031 15.4572C16.0156 15.3218 15.7009 14.7547 15.0716 13.6206C14.5195 12.6255 14.0769 11.2348 14.0769 9.33334Z",
    stroke: "#0E1111",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1229 4C19.1595 4 19.9998 3.10457 19.9998 2C19.9998 0.895431 19.1595 0 18.1229 0C17.0864 0 16.2461 0.895431 16.2461 2C16.2461 3.10457 17.0864 4 18.1229 4Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewNotification);
export default __webpack_public_path__ + "static/media/new-notification.9039cab007fdd68b41ddeab2df9a6646.svg";
export { ForwardRef as ReactComponent };